import { render, staticRenderFns } from "./auth_phone.vue?vue&type=template&id=23feaf0f&scoped=true"
import script from "./auth_phone.vue?vue&type=script&lang=js"
export * from "./auth_phone.vue?vue&type=script&lang=js"
import style0 from "./auth_phone.vue?vue&type=style&index=0&id=23feaf0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23feaf0f",
  null
  
)

export default component.exports